/*!
=========================================================
* 締め処理
=========================================================
*/
import React from "react";

import {
  Button,
  Card, CardBody, CardTitle, 
  Table, Col,
  FormGroup, Input, Row,
  Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";

import { Link } from 'react-router-dom';
import Request from '../../common/Request';
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip';
import WithRole from '../FormParts/ButtonWithRole';
import ListBaseCalendar from '../Base/ListBaseCalendar';
import Definition from '../../common/Definition';
import InputText from '../FormParts/InputText'
import InputSelect from '../FormParts/InputSelect'
import InputCheckBox from '../FormParts/InputCheckBox'
import InputDatetime from '../FormParts/InputDatetime'
import OptionConvert from '../../common/OptionConvert';
import _, { select } from 'underscore';
import 'moment/locale/ja'
import moment from 'moment/moment'
import { CONSTRUCTION_REGIST,REQUEST_BOX_STATUS } from '../../variables/codes_map';
// import { postAccountsLog } from "../../common/PostAccountsLog";

moment.locale('ja')

moment.updateLocale('ja', {
  months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  monthsShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
});

var domain = "";

class List extends ListBaseCalendar {

  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      title: '月締め処理',
      monthData:[],
      minYear: 2024,
      disabledYearMonth: 202409,    //2024年9月以降のデータはクリックできない
      closingModalOpenFlag : false,
      rangeModalOpenFlag: false,
      targetMonthId: "", //削除対象の月締めテーブルid
      monthExists: false,
      closingYearMonth: 202410, //締め処理可能月
    };

    this.toggleClosingModal = this.toggleClosingModal.bind(this);
    this.toggleRangeModal = this.toggleRangeModal.bind(this);
    this.modalExtension = this.modalExtension.bind(this);
  }


  componentDidMount(){
    this.fetchMonthData();
  }

  // 月締め後テーブルの一覧を取得
  fetchMonthData() {
    Request.get("/api/closing",{}, res => {
      // const setting = res.data.setting_datetime.value;
      const settingDate = new Date(res.data.setting_datetime.value);
      settingDate.setDate(1);
      settingDate.setMonth(settingDate.getMonth() + 1);
      const closingYearMonth = (settingDate.getFullYear()) * 100 + settingDate.getMonth() + 1;
      this.setState({
        monthData: res.data.month,
        selectedYear: settingDate.getFullYear(),
        selectedMonth: settingDate.getMonth() + 1,
        targetMonthId: "",   //初期化
        monthExists: false,  //初期化
        closingYearMonth: closingYearMonth,
      })
		})
  }


  validate() {
    return Object.keys(this.state.searchData.errors).length===0;
  }

  // 月をクリックした時の処理
  handleMonthClick(clickMonth, monthExists, monthId){
    this.setState({
      selectedMonth: clickMonth,
      monthExists: monthExists,
      targetMonthId: monthId,
      closingModalOpenFlag: true,
    })

  }
  handleOutOfRange(clickMonth, monthExists, monthId){
    this.setState({
      selectedMonth: clickMonth,
      monthExists: monthExists,
      targetMonthId: monthId,
      rangeModalOpenFlag: true,
    })
    console.log("out of rangeです");
    return ;
  }

  toggleClosingModal() {
    this.setState({
      closingModalOpenFlag: !this.state.closingModalOpenFlag
    });
  }
  toggleRangeModal() {
    this.setState({
      rangeModalOpenFlag: !this.state.rangeModalOpenFlag
    });
  }

  // 締め処理
  async modalExtension() {
    const {selectedYear, selectedMonth, monthExists, targetMonthId} = this.state;
    if(!selectedYear && !selectedMonth) {
      return;
    }

    const data = { selectedYear, selectedMonth }
    // 締め処理実行
    if(!monthExists){
      Request.post('/api/closing', data, res=>{
        console.log(res.data);
  
        this.props.alertModal.current.confirmCheck({
          title: res.data.message,
          messageNo: 2507,
          closeBtn: false
        }, ()=>{
          this.fetchMonthData(); // 画面のリロードを防ぐ
          this.toggleClosingModal();
        }, false)
      })
    }else{
      if(!targetMonthId){
        console.log("月締めidがありません。");
        return
      }
      // 締め処理キャンセル
      Request.put(`/api/closing/${targetMonthId}`, data, res=>{
        console.log(res.data)
        this.props.alertModal.current.confirmCheck({
          title: res.data.message,
          messageNo: 2507,
          closeBtn: false
        }, ()=>{
          this.fetchMonthData(); // 画面のリロードを防ぐ
          this.toggleClosingModal();
        }, false)
      })
    }
  }

  // モーダル
  dialog_defines() {
    return (
      <Modal isOpen={this.state.closingModalOpenFlag} toggle={this.toggleClosingModal}>
        <ModalHeader className="justify-content-center" toggle={this.toggleClosingModal}>
          {this.state.selectedYear}年{this.state.selectedMonth}月
        </ModalHeader>
        <ModalBody style={this.state.monthExists ? {color:"red"} : {} }>
          {this.state.selectedYear}年{this.state.selectedMonth}月{this.state.monthExists ? "の締め処理をキャンセルします" :"の締め処理を実行します"}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button className="pos_center" onClick={this.modalExtension}>
            {this.state.monthExists ? "この月以降の締め処理を解除する" : "この月まで締める" }
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
  // モーダル
  dialog_out_of_range() {
    return (
      <Modal isOpen={this.state.rangeModalOpenFlag} toggle={this.toggleRangeModal}>
        <ModalHeader className="justify-content-center" toggle={this.toggleRangeModal}>
          {this.state.selectedYear}年{this.state.selectedMonth}月
        </ModalHeader>
        <ModalBody style={{color:"red"}}>
          クリックした月より前に締め処理が行われていない月があるため、処理が実行できません。
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button className="pos_center" onClick={this.toggleRangeModal}>
            {"閉じる"}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default List
